import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=1ce3aa6c&scoped=true&lang=html&"
import script from "./InvoicesPage.vue?vue&type=script&lang=js&"
export * from "./InvoicesPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesPage.vue?vue&type=style&index=0&id=1ce3aa6c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3aa6c",
  null
  
)

export default component.exports